// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EnterOutlinedSvg from "@fishx/icons-svg/es/asn/EnterOutlined";
import FishxIcon from '../components/FishxIcon';

var EnterOutlined = function EnterOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: EnterOutlinedSvg
  }));
};

EnterOutlined.displayName = 'EnterOutlined';
export default React.forwardRef(EnterOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/EnterOutlined.js
// module id = 2599
// module chunks = 0